import type { VerifiedCheckoutPurchase } from "../../../src/billing/checkout-purchase";

interface ConversionSink {
  tagId: string;
  sendTo?: string;
  emit: (name: string, params: Record<string, unknown>) => void;
  alreadySent: (key: string) => boolean;
  markSent: (key: string) => void;
}

/** This accepts server-verified orders only; top-ups never become Ads goals. */
export function reportSubscriptionPurchase(
  params: VerifiedCheckoutPurchase,
  sink: ConversionSink,
): void {
  if (!params.isSubscription || !params.transactionId || !(params.value > 0)) return;
  const dedupeKey = `purchase:${params.transactionId}`;
  if (sink.alreadySent(dedupeKey)) return;

  const currency = params.currency ?? "USD";
  const purchaseParams: Record<string, unknown> = {
    transaction_id: params.transactionId,
    currency,
    send_to: sink.tagId,
  };
  if (typeof params.value === "number") purchaseParams.value = params.value;
  if (params.itemName) {
    purchaseParams.items = [
      {
        item_id: params.itemName,
        item_name: params.itemName,
        quantity: 1,
        ...(typeof params.value === "number" ? { price: params.value } : {}),
      },
    ];
  }
  sink.emit("purchase", purchaseParams);

  // Optional Ads event snippet. No-op until VITE_GADS_PURCHASE_SEND_TO
  // is set. Configure this label as the paid subscription acquisition goal.
  const sendTo = sink.sendTo?.trim();
  if (sendTo) {
    sink.emit("conversion", {
      send_to: sendTo,
      currency,
      transaction_id: params.transactionId,
      ...(typeof params.value === "number" ? { value: params.value } : {}),
    });
  }

  sink.markSent(dedupeKey);
}
